import "../../components/Landing/Landing.css";
import "../../components/Landing/Animate.css";
import Footer from "../../components/Landing/Footer";
import Navbar from "../../components/Landing/Header/Navbar";
import TopHeader from "../../components/Landing/Header/TopHeader";

const HomeLayout = ({ children }) => {
  return (
    <>
      {/* Overlay Header Wrapper */}
      <div className="absolute top-0 left-0 w-full z-50">
        <TopHeader />
        <Navbar />
      </div>

      {/* Page Content */}
      {children}

      <Footer />
    </>
  );
};

export default HomeLayout;
